import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Home, ListChecks, Wallet, Users, User, LogOut, Heart } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/app/beranda', label: 'Beranda', icon: Home },
  { to: '/app/checklist', label: 'Checklist', icon: ListChecks },
  { to: '/app/anggaran', label: 'Anggaran', icon: Wallet },
  { to: '/app/undangan', label: 'Undangan', icon: Users },
  { to: '/app/profil', label: 'Profil', icon: User }
];

export default function AppLayout() {
  const location = useLocation();
  const { couple, logout } = useAuth();

  return (
    <div className="min-h-screen bg-cream-100 flex">
      <aside className="hidden lg:flex fixed left-0 top-0 bottom-0 w-64 bg-white/70 backdrop-blur-md border-r border-cream-200 flex-col py-8 px-5 z-40">
        <div className="flex items-center gap-2 mb-10 px-2">
          <div className="w-9 h-9 rounded-full bg-terracotta-500 flex items-center justify-center">
            <Heart className="w-4 h-4 text-white" fill="white" />
          </div>
          <div>
            <div className="font-serif text-lg text-sage-600 leading-none">Naik Pelaminan</div>
            <div className="text-[10px] text-terracotta-600 tracking-widest mt-1">DARI RENCANA SAMPAI AKAD</div>
          </div>
        </div>

        <nav className="flex-1 flex flex-col gap-1">
          {navItems.map(item => {
            const Icon = item.icon;
            const active = location.pathname.startsWith(item.to);
            return (
              <NavLink key={item.to} to={item.to}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${active ? 'bg-terracotta-500 text-white shadow-sm' : 'text-sage-600 hover:bg-cream-200/70'}`}>
                <Icon className="w-5 h-5" strokeWidth={2} />
                <span className="font-medium text-sm">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="mt-auto">
          {couple && (
            <div className="bg-cream-50 rounded-xl p-4 mb-3">
              <div className="text-xs text-sage-500 mb-1">Pasangan</div>
              <div className="font-serif text-sage-600">{couple.brideName} &amp; {couple.groomName}</div>
            </div>
          )}
          <button onClick={logout} className="flex items-center gap-2 text-sm text-sage-500 hover:text-terracotta-600 px-4 py-2">
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </div>
      </aside>

      <main className="flex-1 lg:ml-64 pb-24 lg:pb-8">
        <div className="max-w-5xl mx-auto">
          <Outlet />
        </div>
      </main>

      <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-cream-200 z-40">
        <div className="grid grid-cols-5">
          {navItems.map(item => {
            const Icon = item.icon;
            const active = location.pathname.startsWith(item.to);
            return (
              <NavLink key={item.to} to={item.to}
                className={`flex flex-col items-center gap-1 py-3 transition-colors ${active ? 'text-terracotta-500' : 'text-sage-400'}`}>
                <Icon className="w-5 h-5" strokeWidth={active ? 2.4 : 2} />
                <span className="text-[10px] font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
